import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  title?: string;
  background?: 'white' | 'cream';
};

/** No se muestra si no hay reseñas reales (data/testimonials.ts). */
export function Testimonials({
  voices,
  title = 'What breathwork facilitators say',
  background = 'cream'
}: TestimonialsProps) {
  if (voices.length === 0) return null;
  const bg = background === 'white' ? 'bg-white' : 'bg-cream';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-239" data-mp="31zmqy0c3ttj9">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-240" data-mp="2x0tbi2d9bsgg">
        <div className="text-center" data-id="element-241" data-mp="2x11tu9s5fpz1">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-242" data-mp="2s1ykwe91szls">
            In their own words
          </p>
          <h2 className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-243" data-mp="v8589t0m550o">
            {title}
          </h2>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-244" data-mp="q8iw7mwitutg">
          {voices.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-sand-dark bg-white p-6 shadow-card" data-id="element-245" data-mp="h8aytf4m6trr">
              <QuoteIcon className="h-6 w-6 text-teal" aria-hidden="true" data-id="element-246" data-mp="7925mohkpj6g" />
              <blockquote className="mb-5 mt-3 font-display text-[17px] italic leading-relaxed text-sage" data-id="element-247" data-mp="c623wd86lhn0">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto border-t border-sand-dark pt-4" data-id="element-248" data-mp="14vj3pvy4s0t9">
                <p className="text-sm font-bold text-ink" data-id="element-249" data-mp="14xlre9bt9hut">{item.name}</p>
                {item.role && <p className="text-[13px] text-ink-soft" data-id="element-250" data-mp="q63c6dqrzrci">{item.role}</p>}
                {item.location && <p className="text-xs text-ink-muted" data-id="element-251" data-mp="v44xl5boc2r5">{item.location}</p>}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}